import React from "react";
import T from "prop-types";

import Widget from "2g-widget";
import Buttons, { ButtonsSet } from "2g-buttons";
import Form, { ActionButton } from "2g-form";

import useMessages from "./i18n/useMessages";
import useKonfiguracniParamteryEditaceWidget from "./hooks/useKonfiguracniParamteryEditaceWidget";
import KonfiguracniParamteryEditaceItem from "./KonfiguracniParamteryEditaceItem";

export function KonfiguracniParamteryEditaceWidget() {
  const { title, buttonSubmit } = useMessages();
  const { data, loading, formModuleKey, handleSubmit } =
    useKonfiguracniParamteryEditaceWidget();

  return (
    <Widget
      title={title()}
      collapsable={false}
      className="b2b-KonfiguracniParametryEditaceWidget"
    >
      <Form
        moduleKey={formModuleKey}
        disabled={loading}
        onSubmit={handleSubmit}
      >
        {data?.map((item, index) => (
          <KonfiguracniParamteryEditaceItem
            konfiguracniParametr={item}
            key={item.kod.name}
            index={index}
          />
        ))}

        <ButtonsSet>
          <ActionButton button={Buttons.Primary} validate submit inverse>
            {buttonSubmit()}
          </ActionButton>
        </ButtonsSet>
      </Form>
    </Widget>
  );
}

KonfiguracniParamteryEditaceWidget.propTypes = {
  konfiguracniParametr: T.shape({
    kod: T.string,
    vyznamCs: T.string,
    vyznamEn: T.string,
    hodnotaCs: T.string,
    hodnotaEn: T.string,
    datumUprava: T.number
  })
};

export default React.memo(KonfiguracniParamteryEditaceWidget);
